<template>
  <v-container class="grey lighten-5">
    <v-row>
      <v-col cols="12">
        <div class="text-h5">{{ tituloPagina }}</div>
        <v-divider></v-divider>
      </v-col>
    </v-row>

    <v-row no-gutters>
      <v-col cols="12">
        <v-data-table
          :headers="headers"
          :items="profileList"
          :search="search"
          :custom-filter="filterOnlyCapsText"
        >
          <template v-slot:top>
            <v-toolbar flat color="white">
              <v-col cols="5" class="pa-0">
                <v-text-field
                  v-model="search"
                  prepend-inner-icon="mdi-magnify"
                  label="Pesquisar"
                  single-line
                  hide-details
                ></v-text-field>
              </v-col>

              <v-spacer></v-spacer>

              <v-dialog v-model="dialog" max-width="1000px">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    class="hidden-sm-and-down"
                    dark
                    color="blue"
                    right
                    hide-details
                    v-bind="attrs"
                    v-on="on"
                  >
                    novo
                  </v-btn>

                  <v-btn
                    class="hidden-md-and-up"
                    small
                    dark
                    fab
                    color="blue"
                    right
                    top
                    hide-details
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon>mdi-plus</v-icon>
                  </v-btn>
                </template>

                <v-card>
                  <v-card-title>
                    <span class="headline">{{ tituloModal }}</span>
                  </v-card-title>
                  <v-card-text>
                    <v-divider></v-divider>

                    <v-container>
                      <v-row>
                        <v-col cols="12" md="9">
                          <v-text-field
                            v-model="editedItem.nome"
                            label="Nome"
                            hide-details
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card-text>

                  <v-card-actions>
                    <v-spacer></v-spacer>

                    <v-btn color="blue darken-1" text @click="close"
                      >Cancelar</v-btn
                    >
                    <v-btn color="blue darken-1" text @click="save"
                      >Salvar</v-btn
                    >
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-toolbar>
          </template>

          <template v-slot:[`item.acao`]="{ item }">
            <v-icon small class="mr-2" @click="editItem(item)"
              >mdi-pencil</v-icon
            >
            <v-icon small @click="deleteItem(item)">mdi-delete</v-icon>
          </template>
          
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import header from '../../components/jsonsHelper/headers.json';
  import { mapActions, mapState } from 'vuex';

  export default {
    data: () => ({
      tituloPagina: 'Cadastro de perfis',
      headers: [],
      search: '',
      dialog: false,
      dadosTabela: [],
      editedIndex: -1,
      editedItem: {
        nome: '',
      },
      defaultItem: {
        nome: '',
      },
    }),

    computed: {
      ...mapState('profile', ['profileList']),
      tituloModal() {
        return this.editedIndex === -1 ? 'Novo perfil' : 'Editar perfil';
      },
    },

    watch: {
      dialog(val) {
        val || this.close();
      },
    },

    created() {
      this.initialize();
    },

    methods: {
      ...mapActions('profile', [
        'getProfileList',
        'deleteProfile',
        'createProfile',
        'changeProfileData',
      ]),
      initialize() {
        this.headers = header.perfilHeaders;
        this.getProfileList();
        /* falls through */
      },

      filterOnlyCapsText(value, search) {
        search = search.toString().toLocaleUpperCase();
        return (
          value != null &&
          search != null &&
          typeof value === 'string' &&
          value
            .toString()
            .toLocaleUpperCase()
            .indexOf(search) !== -1
        );
      },

      editItem(item) {
        this.editedIndex = this.dadosTabela.indexOf(item);
        this.editedItem = Object.assign({}, item);
        this.dialog = true;
      },

      deleteItem(item) {
        confirm(
          'Tem certeza que deseja excluir este registro definitivamente? (Esta ação não poderá ser desfeita)',
        ) &&
          this.deleteProfile(item.id).then((status) => {
            status === 200 && this.getProfileList().then(() => this.close());
          });
      },

      close() {
        this.dialog = false;
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem);
          this.editedIndex = -1;
        })
      },

      async save() {
        const resp = this.isEditingItem
          ? await this.editProfile(this.editedItem)
          : await this.createProfile(this.editedItem);
        resp === 200 && this.getProfileList().then(() => this.close());
        this.close();
      },
    },
  };
</script>
